import { render, staticRenderFns } from "./ApprovalTemplates.vue?vue&type=template&id=69036d67&scoped=true"
import script from "./ApprovalTemplates.vue?vue&type=script&lang=js"
export * from "./ApprovalTemplates.vue?vue&type=script&lang=js"
import style0 from "./ApprovalTemplates.vue?vue&type=style&index=0&id=69036d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69036d67",
  null
  
)

export default component.exports